/* Sort state for the franchise Lock and Container tables. */

/** No column sorted: the list keeps the server's default order (newest first). */
export const NO_SORT = { field: null, dir: null };

/**
 * The next sort after clicking a column: ascending, then descending, then
 * back to the default order.
 *
 * @param {{field: string|null, dir: "asc"|"desc"|null}} current
 * @param {string} field Column clicked (the API's sort_by value)
 * @returns {{field: string|null, dir: "asc"|"desc"|null}}
 */
export function nextSort(current, field) {
  if (current.field !== field) return { field, dir: "asc" };
  if (current.dir === "asc") return { field, dir: "desc" };
  return NO_SORT;
}

/**
 * Query params for a sort, to spread into a list request. Empty when no
 * column is sorted, so the server applies its own default.
 *
 * @param {{field: string|null, dir: "asc"|"desc"|null}} sort
 * @returns {{sort_by?: string, sort_dir?: string}}
 */
export function sortParams(sort) {
  return sort?.field ? { sort_by: sort.field, sort_dir: sort.dir } : {};
}
